import { z } from 'zod';
import { LocalStorage } from '@mentimeter/storage';
import { DEPRECATED_SPLIT_KEY_PREFIX, VISITOR_DATA_PREFIX } from '../constants';

export const DEFAULT_LOCALE = 'en-US' as const;
export const PREFERRED_LANGUAGE_KEY = 'preferredLanguage' as const;
export const LOCALE_SCHEMA = z
  .enum(['en-US', 'pt-BR', 'es-ES', 'de-DE'])
  .nullable();
export type Locale = z.infer<typeof LOCALE_SCHEMA>;

export function getPreferredLanguageFromLocalStorage(): Locale {
  const locale =
    LocalStorage.getItem(VISITOR_DATA_PREFIX + PREFERRED_LANGUAGE_KEY) ??
    LocalStorage.getItem(DEPRECATED_SPLIT_KEY_PREFIX + PREFERRED_LANGUAGE_KEY);

  const parsedLocale = LOCALE_SCHEMA.safeParse(locale);

  if (!parsedLocale.success) {
    return null;
  }

  return parsedLocale.data;
}

export function setPreferredLanguageInLocalStorage(
  language: string | null,
): void {
  if (language && LOCALE_SCHEMA.safeParse(language).success) {
    LocalStorage.setItem({
      key: VISITOR_DATA_PREFIX + PREFERRED_LANGUAGE_KEY,
      value: language,
      type: 'functional',
    });
  }
}
